import { DosageTemplate, DosageTemplateCreateCommand } from '@dreryk/egabinet-prescription-frontend-api';

import { PromiseVoidFunction } from '@dreryk/react-common';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import { mapFormBeanToExtendedDosage } from '../../prescriptions/prescription/extendedDosage/extendedDosage.utils';
import {
   ExtendedDosageFormBean,
   ExtendedDosageFormController,
} from '../../prescriptions/prescription/extendedDosage/form/ExtendedDosageForm.types';

type DosageTemplatesCreateTemplateButtonProps = {
   readonly handleSubmit: ExtendedDosageFormController['handleSubmit'];
   readonly onSuccess: PromiseVoidFunction;
   readonly disabled: boolean;
};

const commandCreator = (parameters: ExtendedDosageFormBean): DosageTemplateCreateCommand => {
   const command = new DosageTemplateCreateCommand();
   command.name = parameters.templateName!;
   command.extendedDosage = mapFormBeanToExtendedDosage(parameters);
   return command;
};

export const DosageTemplatesCreateTemplateButton = (props: DosageTemplatesCreateTemplateButtonProps): JSX.Element => {
   return (
      <FormsTemplates.SendTemplateButton<ExtendedDosageFormBean, DosageTemplate>
         disabled={props.disabled}
         handleSubmit={props.handleSubmit}
         commandCreator={commandCreator}
         onSuccess={props.onSuccess}
      />
   );
};
